import { SSOTypes } from '@kaltura-ott/ms-ott-clients';

function normalizeKalturaValue(data: SSOTypes.KalturaStringValue) {
  return data.value;
}

/**
 * Transforms SSOTypes.KalturaStringValue objects to flat key-value object
 * @param data
 */
function normalizeKalturaObject(data: Record<string, SSOTypes.KalturaStringValue>) {
  const result: Record<string, string> = {};
  Object.keys(data).forEach((key) => {
    const normalizedKalturaValue = normalizeKalturaValue(data[key]);

    if (normalizedKalturaValue) {
      result[key] = normalizedKalturaValue;
    }
  });
  return result;
}

export interface NormalizedSSOResponse {
  adapterData: Record<string, string>;
  code?: string | null;
  message?: string | null;
}

/**
 * Flattens adapter data into plain object
 * @param data
 */
export function normalizeSSOResponse(data: SSOTypes.InvokeOkResponse): NormalizedSSOResponse {
  const adapterData: Record<string, string> = data.adapterData ? normalizeKalturaObject(data.adapterData) : {};
  return {
    adapterData,
    code: data.code,
    message: data.message,
  };
}
